export function skillTreeGladiatorId(treeData, fallbackId = "") {
  return treeData?.gladiator_id || treeData?.id || fallbackId || "";
}

export function skillTreeRespecUrl(treeData, fallbackId = "") {
  const gladiatorId = skillTreeGladiatorId(treeData, fallbackId);
  return gladiatorId ? `/gladiators/${encodeURIComponent(gladiatorId)}/skill-tree/respec` : "";
}